
import './UserForm.css';
import React, { useState, useEffect, useMemo, useCallback } from 'react'
import Axios from '../../axios-proas';
import 'react-phone-input-2/lib/style.css'
import {  CancelBtnOutlineAction } from '../../styles/Common';
import { useTheme } from 'styled-components';
import { Modal } from 'react-bootstrap';
import {  UFBody, UFContainer, UFHeaderTitle } from './UserForm.styled';
import UserEntity from './UserEntity';

function UserForm({ show, uidBailleur, setConfirmationUserModalShow, title, contact, userAdminForUserData, setContact, hierarchicalTemp, niveauTemp, codeBailleur, listOfRoles, entity }) {

    const theme = useTheme()
    const [errors, setErrors] = useState(null);
    const isNewUser = title.startsWith("Ajout");
    const closeModal = () => {
        //setContact(userFormDataCopie)
        setErrors(null)
        setConfirmationUserModalShow(false)
    }

    return (
        <>
            <Modal show={show} onHide={closeModal} contentClassName="modal_w_mc_user" >
                <Modal.Header closeButton>
                    <Modal.Title className=""> {title}</Modal.Title>
                </Modal.Header>
                <Modal.Body className="UserCreationModal__body" style={{ }}>
                    <UFContainer>
                        <UFBody>
                            {
                                errors && errors.length > 0 ? (
                                    <div className="alert alert-danger mt-2" role="alert">
                                        <ul>
                                            {
                                                errors.map(error => (<li key={error}>{error}</li>))
                                            }
                                        </ul>
                                    </div>
                                ) : null
                            }

                            <UserEntity entity={entity} contact={contact} userAdminForUserData={userAdminForUserData} uidBailleur={uidBailleur} show={show} listOfRoles={listOfRoles} closeModal={setConfirmationUserModalShow} hierarchicalTemp={hierarchicalTemp} niveauTemp={niveauTemp} codeBailleur={codeBailleur} isNewUser={isNewUser} />
                        </UFBody>
                    </UFContainer>
                </Modal.Body>
                <Modal.Footer >
              
                    {/*<CancelBtnOutlineAction*/}
                    {/*    color={theme.colors.danger}*/}
                    {/*    border={theme.colors.danger}*/}
                    {/*    onClick={closeModal}*/}
                    {/*>*/}
                    {/*    Annuler*/}
                    {/*</CancelBtnOutlineAction>*/}
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default UserForm
